/**
 * The secure-link landing page's strings (H3.1), used only by
 * `features/secure-link`. They live outside the entry bundle: importing this
 * module adds them to i18next, in both languages, once.
 */
import { i18n } from './index.js';
import en from './locales/links.en.json';
import zhCN from './locales/links.zh-CN.json';

i18n.addResourceBundle('en', 'translation', en, true, false);
i18n.addResourceBundle('zh-CN', 'translation', zhCN, true, false);
